import { ChevronDown, LifeBuoy, MessageSquare } from 'lucide-react';
import toast from 'react-hot-toast';
import { NavLink } from 'react-router-dom';
import ResetHistoryButton from '../components/others/ResetHistoryButton';
import useCurrentUser from '../components/user/useCurrentUser';
import './LeftSidebar_bottom.scss';

function LeftSidebarBottom() {
  const { currentUser } = useCurrentUser();

  const handleMenuClick = (e, type) => {
    e.preventDefault();
    toast.success(`${type} feature coming soon!`, {
      duration: 2000,
      position: 'top-center',
      style: {
        background: '#374151',
        color: '#fff',
      },
    });
  };

  return (
    <div className="bottom-menu">
      <ResetHistoryButton />
      <NavLink to="/support" className="listItem" onClick={e => handleMenuClick(e, 'Support')}>
        <LifeBuoy className="w-4 h-4" />
        <span>Support</span>
      </NavLink>
      <NavLink to="/feedback" className="listItem" onClick={e => handleMenuClick(e, 'Feedback')}>
        <MessageSquare className="w-4 h-4" />
        <span>Feedback</span>
      </NavLink>
      <div className="listItem">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center gap-2">
            {currentUser?.empAvatar ? (
              <img
                src={currentUser.empAvatar}
                alt="Profile"
                className="w-9 h-9   rounded-full object-cover  border-gray-400"
              />
            ) : (
              <div className="w-9 h-9 rounded-sm bg-gray-600 flex items-center justify-center text-white">
                {currentUser?.empRole?.charAt(0).toUpperCase() || '?'}
              </div>
            )}
            <div className="flex flex-col">
              <span className="font-medium">{currentUser?.empRole || 'Loading...'}</span>
              <span className="text-gray-400">{currentUser?.empEmail || 'Loading...'}</span>
            </div>
          </div>
          <ChevronDown className="w-4 h-4" />
        </div>
      </div>
    </div>
  );
}

export default LeftSidebarBottom;
